import ReturnMessage from "../shared/ReturnMessage";
import TextInput from "../ui/TextInput";
import Button from "../ui/Button";
import { useContext, useEffect, useState } from "react";
import usePost from "../../hooks/usePost";
import portalContext from "../../store/PortalContext";
import LoadingOverlay from "../shared/LoadingOverlay";
import { formatToday } from "../../utilities/date";

const PortalLoginForm = ({ loginComplete, forgottenPassword }) => {
    // State
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [validateForm, setValidateForm] = useState(false);

    // Hooks
    const { sending, returnMessage, returnData: loginData, postData } = usePost();
    const authCtx = useContext(portalContext);

    // Submit
    const submitHandler = (e) => {
        e.preventDefault();
        setValidateForm(true);

        // Form complete
        if (email && password) {
            const formData = {
                email: email,
                password: password,
            };

            // Post
            postData(formData, "/api/portal/login", 500);
        }
    };

    // Use effect
    useEffect(() => {
        if (loginData) {
            // Set login date and time
            const formatDate = formatToday();
            const formatTime = new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
            const lastLoginDateTime = `Last login on ${formatDate} at ${formatTime}`;

            const roleName = loginData.role.name;
            const profileName = loginData.profile.name;

            // Login context
            authCtx.login(loginData.id, loginData.full_name, loginData.email, roleName, profileName, lastLoginDateTime);

            // Login complete
            loginComplete();
        }
    }, [authCtx, loginComplete, loginData]);

    return (
        <>
            <div className="login-form">
                <ReturnMessage inline={true} returnMessage={returnMessage} />

                <div className="login-form__body">
                    <div className="login-form__body__title">Sign in to view your account</div>
                    <div className="login-form__body__intro">Please provide your password to proceed</div>

                    <form onSubmit={submitHandler}>
                        <TextInput
                            id="email"
                            validateForm={validateForm}
                            label="Email*"
                            required
                            disabled={sending}
                            value={(value) => setEmail(value)}
                            marginBottom
                            validation="email"
                        />
                        <TextInput
                            id="password"
                            validateForm={validateForm}
                            label="Password*"
                            required
                            type="password"
                            maxLength="30"
                            disabled={sending}
                            value={(value) => setPassword(value)}
                        />

                        <div className="login-form__body__submit-container">
                            <Button disabled={sending} classNames={["button--full"]}>
                                Sign In
                            </Button>
                        </div>
                    </form>
                </div>
            </div>

            {sending && <LoadingOverlay />}
        </>
    );
};

export default PortalLoginForm;
